import { MoonLoader } from "react-spinners";

import { colors } from "@design-system/tokens/colors";

type Color = "primary" | "secondary" | "white";

type Props = {
  color?: Color;
  size?: number;
};

export const Spinner = ({ color = "primary", size = 14 }: Props) => {
  return <MoonLoader size={size} color={colors[color]} />;
};
